import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Navigation, Pagination } from 'swiper/modules';
import { bindSwiperNavigationA11y } from '../common/syncSwiperNavigationA11y';

export default class Professionals {

    constructor() {
        this.sections = [...document.querySelectorAll('.block-professionals')];
        this.instances = [];
        this.handleResize = this.debounce(this.rebuild.bind(this), 300);

        this.ready();
        window.addEventListener('resize', this.handleResize);
    }

    debounce(fn, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, args), delay);
        };
    }

    rebuild() {
        this.instances.forEach(obj => {
            obj.main?.destroy(true, true);
        });
        this.sections.forEach(section => delete section.dataset.professionalsInitialized);
        this.instances = [];
        this.ready();
    }

    add(root) {
        const sections = root.matches?.('.block-professionals')
            ? [root]
            : [...root.querySelectorAll('.block-professionals')];

        sections.forEach(section => {
            if (!this.sections.includes(section)) {
                this.sections.push(section);
            }
        });

        this.ready(sections);
    }

    ready(sections = this.sections) {
        if (sections.length === 0) return;

        sections.forEach(section => {
            if (section.dataset.professionalsInitialized === 'true') return;

            const slider = section.querySelector('.swiper');
            if (!slider) return;

            const navigationNext = section.querySelector('.slider-button-next');
            const navigationPrev = section.querySelector('.slider-button-prev');
            const pagination = section.querySelector('.swiper-pagination');
            const navigationContainer = section.querySelector('.swiper-navigation');

            const syncNavigationVisibility = swiper => {
                if (!navigationContainer) return;

                const hasMultipleSlides = swiper.slides.length > 1;
                navigationContainer.classList.toggle('hidden', !hasMultipleSlides || swiper.isLocked);
            };

            const swiperInstance = new Swiper(slider, {
                modules: [Navigation, Pagination],
                spaceBetween: 24,
                grabCursor: true,
                watchSlidesProgress: true,
                watchOverflow: true,
                navigation: navigationNext && navigationPrev ? {
                    nextEl: navigationNext,
                    prevEl: navigationPrev,
                } : false,
                pagination: pagination ? {
                    el: pagination,
                    clickable: true,
                } : false,
                breakpoints: {
                    0: {
                        slidesPerView: 1,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                    },
                    1024: {
                        slidesPerView: 'auto',
                        slidesOffsetAfter: 28,
                    }
                },
                on: {
                    init: syncNavigationVisibility,
                    lock: syncNavigationVisibility,
                    unlock: syncNavigationVisibility,
                    update: syncNavigationVisibility,
                }
            });

            syncNavigationVisibility(swiperInstance);
            bindSwiperNavigationA11y(swiperInstance);

            this.instances.push({ main: swiperInstance });
            section.dataset.professionalsInitialized = 'true';
        });
    }
}

const professionals = new Professionals();
window.initProfessionalsCarousels = root => professionals.add(root);
